import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, Row, UiBox, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {
  PRODUCT_SKUS,
  WEIGHT_LOSS_KEYS,
  WEIGHT_LOSS_ONE_QUESTIONNAIRES,
  WL_PROGRAMS,
} from '~/constants/medical-questionnaires';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import mdqReview from '~/assets/images/mdq-review.png';
import doctorTel from '~/assets/images/doctor-tel.png';

interface Props {}

const Questionnaire10DoctorScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.DOCTOR_CONSULTATION);
  const selectedProgram = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_KEYS.PROGRAM_SELECTION],
  );

  const collectedData = mdq.collectedData;

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.DOCTOR_CONSULTATION,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    const selectedPackage = {
      key: WEIGHT_LOSS_KEYS.PACKAGE_SELECTION,
      index: questionnaire?.index || '',
      data: {
        productSkus: [PRODUCT_SKUS.DOCTOR_TEL],
      },
      order: answerOrder + 2,
    };

    let newSelectedProgram;

    if (selectedProgram?.data?.selectedProgram !== WL_PROGRAMS.LET_DOCTOR_DECIDE.value) {
      newSelectedProgram = {
        ...selectedProgram,
        key: WEIGHT_LOSS_KEYS.PROGRAM_SELECTION,
        data: {
          selectedProgram: WL_PROGRAMS.LET_DOCTOR_DECIDE.value,
          selectedProgramLocal: WL_PROGRAMS.LET_DOCTOR_DECIDE.localValue,
        },
      };
      dispatch(setQuestionnaireAnswer(newSelectedProgram));
    }

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(setQuestionnaireAnswer(selectedPackage));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.DOCTOR_CONSULTATION]: answerData,
            [WEIGHT_LOSS_KEYS.PACKAGE_SELECTION]: selectedPackage,
            ...(newSelectedProgram ? {[WEIGHT_LOSS_KEYS.PROGRAM_SELECTION]: newSelectedProgram} : {}),
          },
        },
      }),
    );
    history.push(PAGE_URLS.MDQ1_APPOINTMENT_PREFERENCES);
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      handleOnNext={onClickSubmit}
      pageTitle={questionnaire?.title}
    >
      <Col alignItems="center" textAlign="center" mt={12} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={4}>
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.descriptions?.default?.map((item, index) => {
          return (
            <UiText key={index} fontSize="sm" mt={5}>
              {item}
            </UiText>
          );
        })}
        <Col bg="#EEF2DC" w="100%" borderRadius="0.625rem" px={6} py={5} mt={7}>
          <UiText textAlign="left" fontSize="xs" fontWeight="600" mb={1}>
            Phase 1
          </UiText>
          <UiText textAlign="left" fontSize="md" fontWeight="bold" mb={4}>
            Doctor consultation
          </UiText>
          <Row textAlign="left" alignItems="center" mb={4}>
            <img src={mdqReview} alt="MDQ Review" style={{width: '1.5rem', height: '1.5rem', objectFit: 'contain'}} />

            <UiText fontSize="xs" fontWeight="400" ml={4}>
              Medical questionnaire reviewed by a doctor
            </UiText>
          </Row>
          <Row textAlign="left" alignItems="flex-start" mb={7}>
            <img src={doctorTel} alt="Doctor Tel" style={{width: '1.5rem', height: '1.5rem', objectFit: 'contain'}} />
            <UiText fontSize="xs" fontWeight="400" ml={4}>
              Teleconsultation with a doctor to discuss your status, goals and guide you on your medication
            </UiText>
          </Row>
          <Row
            bg="white"
            justifyContent="space-between"
            borderRadius="0.625rem"
            border="1px solid #E7EBF1"
            py={2}
            pl={3}
            pr={4}
          >
            <UiText fontSize="sm" fontWeight="600">
              One time payment
            </UiText>
            <UiText fontSize="md" fontWeight="600">
              $21.8
            </UiText>
          </Row>
        </Col>
        <UiText fontSize="sm" mt={6}>
          {questionnaire?.descriptions?.sub}
        </UiText>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire10DoctorScreen;
